import { render, staticRenderFns } from "./discountType.vue?vue&type=template&id=905b9a58&"
import script from "./discountType.vue?vue&type=script&lang=js&"
export * from "./discountType.vue?vue&type=script&lang=js&"
import style0 from "./discountType.vue?vue&type=style&index=0&id=905b9a58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports